import React from 'react';
import { useQueries } from '@magoosh/gre/app/queries';
import { Chunk, StudyPlanDataInterface, StudyPlanItem } from '../types';
import { paths } from 'config/path_helpers';

import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import style from './style.module.scss';

interface SecondaryCTAProps {
  chunk?: Chunk;
  item: StudyPlanItem;
  planType: StudyPlanDataInterface['planType'];
}

const SecondaryCTA: React.FC<SecondaryCTAProps> = ({ chunk, item, planType }) => {
  if (item.completedAt) return null;
  
  const q = useQueries();
  const goToCustomPractice = {
    href: paths.startPractice,
    text: 'Go to Custom Practice'
  };
  const goToVocabularyFlashcards = {
    href: paths.vocabularyFlashcards,
    text: 'Go to Vocabulary Flashcards'
  };
  const markCompleted = {
    onClick: () => q.markStudyPlanItemCompleteMutation.mutate(item),
    text: 'Mark Completed'
  };
  const removeFromPlan = {
    onClick: () => q.hideStudyPlanItemMutation.mutate({ item, permanent: true }),
    text: 'Remove from Plan'
  };
  const skip = {
    onClick: () => q.hideStudyPlanItemMutation.mutate({ item, permanent: false }),
    text: 'Skip'
  };
  const start = {
    href: item.primaryCta?.href,
    text: 'Start'
  };

  let itemCategory = null;
  if (planType === 'adaptive') {
    if (chunk.isSubjectToChange) {
      itemCategory = 'preview';
    } else if (item.type === 'Segment' && chunk.number !== 0) {
      itemCategory = 'nonPreviewLater';
    } else {
      itemCategory = 'nonPreview';
    }
  }

  const adaptiveCTAs = {
    preview: {
      'Segment': [start, removeFromPlan, markCompleted],
      'Practice': [goToCustomPractice, markCompleted],
      'Vocabulary': [goToVocabularyFlashcards, markCompleted]
    },
    nonPreview: {
      'Segment': [skip, removeFromPlan, markCompleted],
      'Practice': [skip, markCompleted],
      'Vocabulary': [skip, markCompleted]
    },
    nonPreviewLater: {
      // TODO - add moveToToday option
      'Segment': [removeFromPlan, markCompleted]
    }
  };

  const ctas = planType === 'preset' ? [markCompleted] : adaptiveCTAs[itemCategory][item.type];
  if (!ctas || ctas.length === 0) return null;

  return (
    <Dropdown pullRight id={`dropdown-${item.id || item.uuid}`}>
      <Dropdown.Toggle className={style.dropdownToggle} noCaret>
        <FontAwesomeIcon icon="ellipsis-h" />
      </Dropdown.Toggle>
      <Dropdown.Menu className={style.dropdownMenu}>
        <h4 className="u-margin-T-n">
          <strong>More Actions</strong>
        </h4>
        
        {
          // TODO - use <ContextualLink> below to get SPA routing to segments
          ctas.map((cta, idx) => (
            <MenuItem className={style.dropdownItem} key={idx} {...cta}>              
              {cta.text}
            </MenuItem>
          ))
        }
      </Dropdown.Menu>
     </Dropdown>
  );
};

export default SecondaryCTA;
